import React, { useEffect, useState } from "react";
import Loader from "../../Loader/Loader";
import DashboardMenu from "../layout/dashboardMenu";
import Header from "../layout/header";
import "./outofoffice.css";
import DropDownInput from "../Input/dropDownInput/dropDownInput";
import { toast } from "react-toastify";
import SuccessModal from "../CustomModal/Success";
import FailedModal from "../CustomModal/Failed";
import axios from "axios";
import useLatLng from "../../hooks/uselatlng/uselatlng";
import useCurrentlocation from "../../hooks/currentlocation/useCurrentlocation";
import geocode from "../Geocode";

const NotAtSiteAttendance = ({
  match,
  history,
  markCheckIn,
  insertNonSiteAttendance = [],
  getTheAttendanceDetails,
  attendanceDetails = [],
  markCheckOut,
  nonSiteCheckout = [],
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
  const [countToOpenModal, setCountToOpenModal] = useState(0);
  const islatlng = useCurrentlocation();
  const [inputList, setInputList] = useState({
    location_of_work: "",
    office_location: "",
    check_in_date: "",
    check_in_time: "",
    check_in_comments: "",
  });
  const [checkOutInput, setCheckOutInput] = useState({
    check_out_time: "",
    check_out_comments: "",
  });
  const [mapLocation, setMapLocation] = useState({
    address: "Delhi",
    formatted_address: null,
    lat: 0,
    lng: 0,
  });
  const [isLocationAllowed, setIsLocationAllowed] = useState(true);

  const handleCheckoutInputChange = (val, field) => {
    setCheckOutInput((prevList) => ({
      ...prevList,
      [field]: val,
    }));
  };

  const getCurrentDate = () => {
    const now = new Date();
    return now.toISOString().split("T")[0];
  };

  const getCurrentTime = () => {
    const now = new Date();
    return now.toTimeString().slice(0, 5);
  };

  const handleInputChange = (val, field) => {
    setInputList((prevList) => ({
      ...prevList,
      [field]: val,
    }));
  };

  const particularDate = match.params.date;
  const currentDate = getCurrentDate();

  useEffect(() => {
    const currentTime = getCurrentTime();
    setInputList((prevList) => ({
      ...prevList,
      check_in_date: currentDate,
      check_in_time: currentTime,
    }));
    setCheckOutInput((prevList) => ({
      ...prevList,
      check_out_date: currentDate,
      check_out_time: currentTime,
      id: attendanceDetails?.data?.id,
    }));
  }, [particularDate, attendanceDetails]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getTheAttendanceDetails();
      setIsLoading(false);
    })();
  }, [getTheAttendanceDetails]);

  useEffect(() => {
    setIsFailedModalOpen(false);
    setIsSuccessModalOpen(false);
    if (
      insertNonSiteAttendance?.data !== undefined &&
      insertNonSiteAttendance?.status === 200
    ) {
      setMessage(insertNonSiteAttendance?.message);
      setIsSuccessModalOpen(true);
    } else if (
      insertNonSiteAttendance?.data !== undefined &&
      insertNonSiteAttendance?.status !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
      setMessage(insertNonSiteAttendance?.message);
    }
  }, [insertNonSiteAttendance]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setInputList((prevList) => ({
            ...prevList,
            latitude,
            longitude,
          }));
          setCheckOutInput((prevList) => ({
            ...prevList,
            latitude,
            longitude,
          }));
          setIsLocationAllowed(true);
        },
        (error) => {
          setIsLocationAllowed(false);
          // toast.error("Unable to retrieve location. Please enable location access to check in.");
        }
      );
    } else {
      setIsLocationAllowed(false);
      toast.error("Geolocation is not supported by this browser.");
    }
  }, []);

  const handleCheckIn = async (e) => {
    e.preventDefault();
    // if (inputList.location_of_work === "") {
    //   toast.error("Please select the office location");
    //   return false;
    // }
    // if (
    //   inputList.location_of_work === "In-Office" &&
    //   inputList.office_location === ""
    // ) {
    //   toast.error("Please select the office");
    //   return false;
    // }

    if (inputList.check_in_comments === "") {
      toast.error("Please enter the reason");
      return false;
    }

    let userProfile = localStorage.getItem('user_profile')
    let userDetails = JSON.parse(userProfile)
    const teamIds = userDetails?.teams.map(team => team.team_id);
    if (teamIds.includes(21) && inputList.check_in_comments !== undefined && inputList.check_in_comments.length < 60) {
      toast.warning("Comments must be minimum 60 characters");
      return false;
    }
    setIsLoading(true);
    const res = await markCheckIn(inputList);
    setIsLoading(false);
  };

  const handleCheckout = async (e) => {
    e.preventDefault();
    if (checkOutInput.check_out_comments === "") {
      toast.error("Please enter the reason");
      return false;
    }
    let userProfile = localStorage.getItem('user_profile')
    let userDetails = JSON.parse(userProfile)
    const teamIds = userDetails?.teams.map(team => team.team_id);
    if (teamIds.includes(21) && inputList.check_out_comments !== undefined && inputList.check_out_comments.length < 60) {
      toast.warning("Comments must be minimum 60 characters");
      return false;
    }
    setIsLoading(true);
    const res = await markCheckOut(checkOutInput);
    setIsLoading(false);
  };

  useEffect(() => {
    setIsFailedModalOpen(false);
    setIsSuccessModalOpen(false);
    if (
      nonSiteCheckout?.data !== undefined &&
      nonSiteCheckout?.status === 200
    ) {
      setMessage(nonSiteCheckout?.message);
      setIsSuccessModalOpen(true);
    } else if (
      nonSiteCheckout?.data !== undefined &&
      nonSiteCheckout?.status !== 200
    ) {
      setCountToOpenModal(countToOpenModal + 1);
      setIsFailedModalOpen(true);
      setMessage(nonSiteCheckout?.message);
    }
  }, [nonSiteCheckout]);

  useEffect(() => {
    const fetchData = async () => {
      const address = await geocode(islatlng?.lat, islatlng?.lng);
      setMapLocation({
        ...mapLocation,
        formatted_address: address,
      });
    };
    if (
      islatlng?.lat !== undefined &&
      islatlng?.lng !== undefined &&
      islatlng?.lat !== 0 &&
      islatlng?.lng !== 0 &&
      islatlng?.lat !== null &&
      islatlng?.lng !== null
    ) {
      fetchData();
    }
  }, [islatlng]);

  return (
    <>
      <SuccessModal
        isOpen={isSuccessModalOpen}
        msg={message}
        url={`/monthly-regularization`}
      />

      <FailedModal
        isOpen={isFailedModalOpen}
        msg={message}
        countToOpenModal={countToOpenModal}
      />
      <Loader isLoading={isLoading} />
      <div id="wrapper">
        <DashboardMenu />
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Header title={"Non Site Attendance"} history={history} />
            <div className="container-fluid common-bg">
              {/* If location access is not allowed, display an error message */}
              {!isLocationAllowed ? (
                <div className="alert alert-danger text-center">
                  Location access is required for check-in/check-out. Please
                  enable location access in your browser settings.
                </div>
              ) : (
                <>
                  {(attendanceDetails == null || attendanceDetails?.length > 0 || attendanceDetails?.data == null) && (
                    <div className="container-fluid bootstrap snippets bg-white">
                      <div className="container">
                        <div className="text-center mt-5">
                          <h3>Check-In</h3>
                        </div>
                        {/* <div className="form-group">
                          <label>
                            Location Of Work{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <DropDownInput
                            data={[
                              {
                                id: "In-Office",
                                name: "In-Office",
                              },
                              {
                                id: "Out Of Office",
                                name: "Out Of Office",
                              },
                            ]}
                            label={""}
                            getIdValue={(val) => {
                              handleInputChange(val.id, "location_of_work");
                            }}
                          />
                        </div> */}
                        {/* {inputList.location_of_work == "In-Office" && (
                          <div className="form-group">
                            <label>
                              Select Office <span style={{ color: "red" }}>*</span>
                            </label>
                            <DropDownInput
                              data={[
                                {
                                  id: "1",
                                  name: "Unitech Cyber Park",
                                },
                                {
                                  id: "2",
                                  name: "Udhyog Vihar",
                                },
                              ]}
                              label={""}
                              getIdValue={(val) => {
                                handleInputChange(val.id, "office_location");
                              }}
                            />
                          </div>
                        )} */}
                        {/* <div className="form-group">
                          <label>
                            Date <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            className="date-time"
                            type="text"
                            value={inputList.check_in_date}
                            defaultValue={currentDate}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            Check-in Time <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            className="date-time"
                            type="time"
                            id="timeFrom"
                            value={inputList.check_in_time}
                            onChange={(e) =>
                              handleInputChange(e.target.value, "check_in_time")
                            }
                            defaultValue={getCurrentTime()}
                            disabled
                          />
                        </div> */}
                        <div className="form-group">
                          <label>
                            Coordinates <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            className="disabled-locations"
                            style={{
                              backgroundColor: "rgb(230 242 255)",
                              color: "red !important",
                            }}
                            type="text"
                            value={`${islatlng?.lat || ""}, ${
                              islatlng?.lng || ""
                            }`}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            Address <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            className="disabled-locations"
                            type="text"
                            style={{
                              backgroundColor: "rgb(230 242 255)",
                              color: "black !important",
                            }}
                            value={mapLocation?.formatted_address || ""}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label htmlFor="message">Check-In Comments <span style={{ color: "red" }}>*</span></label>
                          <textarea
                            id="message"
                            placeholder="Type your message"
                            onChange={(e) => {
                              handleInputChange(
                                e.target.value,
                                "check_in_comments"
                              );
                            }}
                          ></textarea>
                        </div>
                        <button
                          className="btn btn-primary"
                          type="submit"
                          onClick={handleCheckIn}
                        >
                          Check-In
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Check-out section */}
                  {attendanceDetails && attendanceDetails?.data !== null && (
                    <div className="container-fluid bootstrap snippets bg-white">
                      <div className="container">
                        <div className="text-center mt-5">
                          <h3>Check-Out</h3>
                        </div>
                        {/* <div className="form-group">
                          <label>
                            Location Of Office{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            className="date-time"
                            type="text"
                            value={attendanceDetails?.data?.module_type}
                            disabled
                          />
                        </div> */}

                        {/* {attendanceDetails?.data?.module_type == "In-Office" && (
                          <div className="form-group">
                            <label>
                              Location Of Work{" "}
                              <span style={{ color: "red" }}>*</span>
                            </label>
                            <input
                              className="date-time"
                              type="text"
                              value={attendanceDetails?.data?.office_location}
                              disabled
                            />
                          </div>
                        )} */}
                        {/* <div className="form-group">
                          <label>
                            Check-in Date-Time{" "}
                            <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            className="date-time"
                            type="text"
                            value={attendanceDetails?.data?.check_in_date}
                            defaultValue={currentDate}
                            disabled
                          />
                        </div>

                        <div className="form-group">
                          <label>Check-Out Time</label>
                          <input
                            type="time"
                            className="date-time"
                            value={checkOutInput.check_out_time}
                            onChange={(e) =>
                              handleCheckoutInputChange(e.target.value, "check_out_time")
                            }
                            defaultValue={getCurrentTime()}
                            disabled
                          />
                        </div> */}
                        <div className="form-group">
                          <label>
                            Coordinates <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            className="disabled-locations"
                            style={{
                              backgroundColor: "rgb(230 242 255)",
                              color: "white !important",
                            }}
                            type="text"
                            value={`${islatlng?.lat || ""}, ${
                              islatlng?.lng || ""
                            }`}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>
                            Address <span style={{ color: "red" }}>*</span>
                          </label>
                          <input
                            className="disabled-locations"
                            type="text"
                            style={{
                              backgroundColor: "rgb(230 242 255)",
                              color: "white !important",
                            }}
                            value={mapLocation?.formatted_address || ""}
                            disabled
                          />
                        </div>
                        <div className="form-group">
                          <label>Check-Out Comments<span style={{ color: "red" }}>*</span></label>
                          <textarea
                            placeholder="Type your comments"
                            onChange={(e) =>
                              handleCheckoutInputChange(
                                e.target.value,
                                "check_out_comments"
                              )
                            }
                          ></textarea>
                        </div>

                        <button
                          className="btn btn-primary"
                          type="submit"
                          onClick={handleCheckout}
                        >
                          Check-Out
                        </button>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {/* section ends */}
    </>
  );
};

export default NotAtSiteAttendance;
